import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { BATTLESHIP, KOALA } from 'visitor-ui-component-library/constants/WidgetColors';
import SearchInput from './SearchInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SearchBoxWrapper = styled.div.withConfig({
  displayName: "SearchBox__SearchBoxWrapper",
  componentId: "z19d6p-0"
})(["padding:16px;background-color:", ";border-bottom:1px solid ", ";"], KOALA, BATTLESHIP);
const SearchBoxHeader = styled.div.withConfig({
  displayName: "SearchBox__SearchBoxHeader",
  componentId: "z19d6p-1"
})(["font-size:16px;line-height:24px;font-weight:600;"]);
export default function SearchBox({
  searchTerm,
  setSearchTerm,
  disabled
}) {
  return /*#__PURE__*/_jsx(SearchBoxWrapper, {
    "data-test-id": "knowledge-base-card",
    children: /*#__PURE__*/_jsxs(SearchBoxHeader, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "helpWidgetComponents.knowledgeBaseSearch.header"
      }), /*#__PURE__*/_jsx(SearchInput, {
        disabled: disabled,
        value: searchTerm,
        onChange: setSearchTerm
      })]
    })
  });
}
SearchBox.displayName = 'SearchBox';